import { render, staticRenderFns } from "./SuccessMessageWithHistoricalLink.vue?vue&type=template&id=103d7ca7&scoped=true"
import script from "./SuccessMessageWithHistoricalLink.ts?vue&type=script&lang=ts&external"
export * from "./SuccessMessageWithHistoricalLink.ts?vue&type=script&lang=ts&external"
import style0 from "./SuccessMessageWithHistoricalLink.vue?vue&type=style&index=0&id=103d7ca7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103d7ca7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('103d7ca7')) {
      api.createRecord('103d7ca7', component.options)
    } else {
      api.reload('103d7ca7', component.options)
    }
    module.hot.accept("./SuccessMessageWithHistoricalLink.vue?vue&type=template&id=103d7ca7&scoped=true", function () {
      api.rerender('103d7ca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/SuccessMessageWithHistoricalLink/SuccessMessageWithHistoricalLink.vue"
export default component.exports